import Axios from '@/utils/union-axios'

const urlPrefix = '/charging'

export function getChargingRecordLatest(params) {
  return Axios.get(`${urlPrefix}/web/charging/chargingRecord/latest`, params)
}
